<template>
  <div class="home">
    <img alt="Vue logo" class="logo" src="../assets/logo.png">
     <div class="intro">
      <h1>{{ $t("tool.intro.title") }}</h1>
      <p v-html='$t("tool.intro.text")'/>
      <p><em>{{ $t("tool.intro.privacy") }}</em></p>
    </div>
    <Tool/>
  </div>
</template>

<script>
import Tool from '@/components/Tool.vue'

export default {
  name: 'Home',
  components: {
    Tool
  },
  mounted () {
     this.$gtag.event('loadHomepage')
  }
}
</script>

<style lang="scss" scoped>
.logo {
  width: 100px;
}

.intro {
  max-width: 550px;
  margin: 0 auto;
}
</style>
